import { Grid, Button, Typography, FormHelperText } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { ICONS } from 'src/assets/library';
import { joinFormScheme, updateUserSchema } from 'src/config/yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { join } from 'src/redux/features/auth/actions';
import LoaderButton from 'src/components/loaderButton/loaderButton';
import CustomTextField from 'src/components/formFields/textField';
import { useParams } from 'react-router-dom';
import CheckBoxField from '../formFields/checkBoxField';
import FirebaseService from 'src/config/firebase/firebaseService';
import { useEffect, useState } from 'react';
import { showErrorTost, showSuccessTost, userStatusArray, VAN_SIZE_OPTIONS } from 'src/constants';
import CustomSelectField from '../formFields/selectField';
import { useModal } from 'src/hooks/useModal';
import { UPDATE_USER } from 'src/apiService/apiDeclaration';

const JoinForm = ({ data, isEdit, onSuccess }) => {
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const { email } = useParams();
  const { handleModalClose } = useModal();
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    formState: { errors, isDirty },
    setValue,
    getValues,
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(isEdit ? updateUserSchema : joinFormScheme),
    defaultValues: {
      _id: data?._id,
      email: email || data?.email,
      name: data?.name,
      phoneNumber: data?.phoneNumber,
      role: data?.role,
      status: data?.status,
      based: data?.based,
      vanSize: data?.vanSize,
      vanReg: data?.vanReg,
      vanMake: data?.vanMake,
      vanModel: data?.vanModel,
      vanColor: data?.vanColor,
      publicLiability: data?.publicLiability,
      goodsInTransit: data?.goodsInTransit,
      vanInsurance: data?.vanInsurance,
      insuranceExpires: data?.insuranceExpires,
      workDays: data?.workDays,
    },
  });

  const onJoin = async (data) => {
    setLoading(true);
    const publicLiability = await FirebaseService.uploadFile(data.publicLiability);
    const goodsInTransit = await FirebaseService.uploadFile(data.goodsInTransit);
    const vanInsurance = await FirebaseService.uploadFile(data.vanInsurance);
    dispatch(join({ ...data, publicLiability, goodsInTransit, vanInsurance }));
    setLoading(false);
  };
  const updateUser = async (body) => {
    try {
      let resp = await UPDATE_USER(body._id, body);
      showSuccessTost(resp.message);
      onSuccess();
    } catch (error) {
      showErrorTost(error.message);
      handleModalClose();
    }
  };

  const handleFileChange = (field, event) => {
    const file = event.target.files[0];
    setValue(field, file); // Set the file in the form state
    console.log('File Selected:', field, file);
    setRefresh(!refresh);
  };
  useEffect(() => {}, [refresh]);
  return (
    <form onSubmit={handleSubmit(isEdit ? updateUser : onJoin)}>
      <Grid container spacing={2.5}>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            label="Email"
            placeholder={'Enter your email'}
            type="email"
            icon={ICONS.email}
            controller={{
              name: 'email',
              control: control,
              errors: errors.email,
            }}
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            disabled={isEdit}
            label="Name"
            placeholder={'Enter your full name'}
            type="name"
            icon={ICONS.user}
            controller={{
              name: 'name',
              control: control,
              errors: errors.name,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            disabled={isEdit}
            label="City Based"
            placeholder={'City Based'}
            type="text"
            icon={ICONS.based}
            controller={{
              name: 'based',
              control: control,
              errors: errors.based,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            label="Van Size"
            placeholder={'Van Size'}
            type="radio"
            icon={ICONS.van}
            controller={{
              name: 'vanSize',
              control: control,
              errors: errors.vanSize,
              disabled: isEdit,
            }}
            radioOptions={VAN_SIZE_OPTIONS}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            disabled={isEdit}
            label="Van Registration"
            placeholder={'Van Reg'}
            type="text"
            icon={ICONS.van}
            controller={{
              name: 'vanReg',
              control: control,
              errors: errors.vanReg,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            disabled={isEdit}
            label="Van Make"
            placeholder={'Van Make'}
            type="text"
            icon={ICONS.van}
            controller={{
              name: 'vanMake',
              control: control,
              errors: errors.vanMake,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            disabled={isEdit}
            label=" Van Model"
            placeholder={'Van Model'}
            type="text"
            icon={ICONS.van}
            controller={{
              name: 'vanModel',
              control: control,
              errors: errors.vanModel,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            disabled={isEdit}
            label="Van Color"
            placeholder={'Van Color'}
            type="text"
            icon={ICONS.van}
            controller={{
              name: 'vanColor',
              control: control,
              errors: errors.vanColor,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            disabled={isEdit}
            label="Phone Number"
            placeholder={'+441234567891'}
            icon={ICONS.phone}
            controller={{
              name: 'phoneNumber',
              control: control,
              errors: errors.phoneNumber,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            disabled={isEdit}
            label="Insurance Expires"
            placeholder={'Insurance Expires'}
            type="date"
            controller={{
              name: 'insuranceExpires',
              control: control,
              errors: errors.insuranceExpires,
            }}
          />
        </Grid>
        {!isEdit ? (
          <Grid item xs={12} sm={6}>
            <CustomTextField
              disabled={isEdit}
              isPassword
              label="Password"
              placeholder={'Password'}
              type="password"
              icon={ICONS.password}
              controller={{
                name: 'password',
                control: control,
                errors: errors.password,
              }}
            />
          </Grid>
        ) : null}
        {!isEdit ? (
          <Grid item xs={12} sm={6}>
            <CustomTextField
              disabled={isEdit}
              label="Confirm Password"
              isPassword
              placeholder={'Confirm Password'}
              type="password"
              icon={ICONS.password}
              controller={{
                name: 'confirmPassword',
                control: control,
                errors: errors.confirmPassword,
              }}
            />
          </Grid>
        ) : null}
        {isEdit ? (
          <Grid item xs={12} sm={6}>
            <Typography>Work Days</Typography>
            {data.workDays?.map((item, index) => {
              return <p key={index}>{item}</p>;
            })}
          </Grid>
        ) : (
          <Grid item xs={12} sm={6}>
            <CheckBoxField
              label="Work Days"
              type="text"
              icon={ICONS.phone}
              setValue={setValue}
              controller={{
                name: 'workDays',
                control: control,
                errors: errors.workDays,
                options: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
              }}
            />
          </Grid>
        )}
        {!isEdit ? (
          <Grid item xs={12} sm={6}>
            <Grid item xs={12} mb={2}>
              <Typography>Public Liability</Typography>

              <label htmlFor="public-liability">
                <Button variant="contained" color="primary" component="span">
                  Choose File
                </Button>
              </label>
              <input
                accept="*"
                style={{ display: 'none' }}
                id="public-liability"
                type="file"
                onChange={(e) => handleFileChange('publicLiability', e)}
              />
              {getValues('publicLiability') && (
                <Typography variant="body1">Selected File: {getValues('publicLiability').name}</Typography>
              )}
              {errors.publicLiability && (
                <FormHelperText sx={{ color: 'error.main' }}>{errors.publicLiability.message}</FormHelperText>
              )}
            </Grid>
            <Grid item xs={12} mb={2}>
              <Typography variant="body1">Goods In Transit</Typography>

              <label htmlFor="goods-in-transit">
                <Button variant="contained" color="primary" component="span">
                  Choose File
                </Button>
              </label>
              <input
                accept="*"
                style={{ display: 'none' }}
                id="goods-in-transit"
                type="file"
                onChange={(e) => handleFileChange('goodsInTransit', e)}
              />
              {getValues('goodsInTransit') && (
                <Typography variant="body1">Selected File: {getValues('goodsInTransit').name}</Typography>
              )}
              {errors.goodsInTransit && (
                <FormHelperText sx={{ color: 'error.main' }}>{errors.goodsInTransit.message}</FormHelperText>
              )}
            </Grid>
            <Grid item xs={12} mb={2}>
              <Typography>Van Insurance</Typography>

              <label htmlFor="van-insurance">
                <Button variant="contained" color="primary" component="span">
                  Choose File
                </Button>
              </label>
              <input
                accept="*"
                style={{ display: 'none' }}
                id="van-insurance"
                type="file"
                onChange={(e) => handleFileChange('vanInsurance', e)}
              />
              {getValues('vanInsurance') && (
                <Typography variant="body1">Selected File: {getValues('vanInsurance').name}</Typography>
              )}
              {errors.vanInsurance && (
                <FormHelperText sx={{ color: 'error.main' }}>{errors.vanInsurance.message}</FormHelperText>
              )}
            </Grid>
          </Grid>
        ) : (
          <>
            <Grid item xs={12} sm={6}>
              <Typography>Documents</Typography>
              <Typography component="a" href={data.publicLiability} target="_blank" style={{ cursor: 'pointer' }}>
                Public Liability
              </Typography>
              <br></br>
              <Typography component="a" href={data.goodsInTransit} target="_blank" style={{ cursor: 'pointer' }}>
                Goods In Transit
              </Typography>
              <br></br>
              <Typography component="a" href={data.vanInsurance} target="_blank" style={{ cursor: 'pointer' }}>
                Van Insurance
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomSelectField
                optionsArray={userStatusArray.slice(1)}
                label={'Status'}
                controller={{
                  name: 'status',
                  control: control,
                  errors: errors.status,
                }}
              />
            </Grid>
          </>
        )}
        {!isEdit ? (
          <Grid item xs={12} sm={12} style={{ padding: '20px', display: 'flex', justifyContent: 'end' }}>
            <LoaderButton loading={loading} buttonText={'Join'} type="submit" />
          </Grid>
        ) : (
          <Grid container item xs={12}>
            <Grid
              item
              xs={12}
              sm={6}
              style={{ padding: '20px', display: 'flex', justifyContent: 'end', marginLeft: 'auto' }}
            >
              <LoaderButton loading={loading} buttonText={'Save'} type="submit" disabled={!isDirty} />
            </Grid>
          </Grid>
        )}
      </Grid>
    </form>
  );
};

export default JoinForm;
